export default {
  // 指令绑定到元素时触发
  bind(el) {
    let isDragging = false; // 是否处于拖拽状态
    let startX = 0; // 鼠标按下时的横坐标
    let startScrollLeft = 0; // 鼠标按下时的滚动位置

    // 鼠标按下事件
    const handleMouseDown = (e) => {
      // 仅响应鼠标左键，过滤右键/中键
      if (e.button !== 0) return;

      isDragging = false;
      startX = e.pageX;
      startScrollLeft = el.scrollLeft;

      // 将移动/松开事件绑定到 document，保证鼠标移出容器也能正常拖拽
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);

      // 阻止默认行为，避免拖拽时选中文本
      e.preventDefault();
    };

    // 鼠标移动事件
    const handleMouseMove = (e) => {
      const deltaX = e.pageX - startX;

      // 移动距离超过 5px 才判定为拖拽，避免点击菜单时误触发
      if (Math.abs(deltaX) > 5) {
        isDragging = true;
      }

      if (isDragging) {
        // 鼠标右移 → 内容右移 → scrollLeft 减小，符合直觉
        el.scrollLeft = startScrollLeft - deltaX;

        // 边界限制：防止滚动超出内容范围
        const maxScroll = el.scrollWidth - el.clientWidth;
        if (el.scrollLeft < 0) el.scrollLeft = 0;
        if (el.scrollLeft > maxScroll) el.scrollLeft = maxScroll;
      }
    };

    // 鼠标松开事件
    const handleMouseUp = () => {
      // 移除全局事件，避免内存泄漏
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);

      // 拖拽状态下，阻止本次后续的 click 事件，避免误触菜单项
      if (isDragging) {
        const preventClick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          el.removeEventListener("click", preventClick, true);
        };
        // 捕获阶段拦截点击，确保优先执行
        el.addEventListener("click", preventClick, true);
      }
    };

    // 绑定鼠标按下事件
    el.addEventListener("mousedown", handleMouseDown);
    // 挂载处理函数到元素上，方便解绑时清理
    el._dragScrollDown = handleMouseDown;
  },

  // 指令与元素解绑时触发（组件销毁）
  unbind(el) {
    el.removeEventListener("mousedown", el._dragScrollDown);
    delete el._dragScrollDown;
  },
};
